module.exports = __webpack_public_path__ + "static/media/layers-enabled.9572625d.svg";